import { endOfMonth, endOfWeek, format, startOfMonth, startOfWeek } from 'date-fns';

export type RangeKind = 'today' | 'week' | 'month';
export interface DateRangeValue { startDate: string; endDate: string }

const ymd = (d: Date) => format(d, 'yyyy-MM-dd');

/** Local-date range for the dashboard / transactions / report segmented control. */
export function rangeFor(kind: RangeKind, now = new Date()): DateRangeValue {
    if (kind === 'week') return { startDate: ymd(startOfWeek(now, { weekStartsOn: 1 })), endDate: ymd(endOfWeek(now, { weekStartsOn: 1 })) };
    if (kind === 'month') return { startDate: ymd(startOfMonth(now)), endDate: ymd(endOfMonth(now)) };
    return { startDate: ymd(now), endDate: ymd(now) };
}

/** Which preset a range matches, if any (so the control can reflect a custom range as none). */
export function kindOf(range: DateRangeValue, now = new Date()): RangeKind | null {
    return (['today', 'week', 'month'] as RangeKind[]).find((k) => {
        const r = rangeFor(k, now);
        return r.startDate === range.startDate && r.endDate === range.endDate;
    }) ?? null;
}

/** Naive local ISO (no Z) for Java LocalDateTime params. */
export const toLocalDateTimeParams = (range: DateRangeValue) => ({
    startDate: new Date(range.startDate + 'T00:00:00').toISOString().replace('Z', ''),
    endDate: new Date(range.endDate + 'T23:59:59').toISOString().replace('Z', ''),
});

export const greetingKey = (hour = new Date().getHours()): 'morning' | 'afternoon' | 'evening' =>
    hour < 11 ? 'morning' : hour < 17 ? 'afternoon' : 'evening';
